import type { User } from '../../models/User.d.ts';
import type { SupabaseClient } from '@supabase/supabase-js';
import { SupabaseRepository } from '../supabaseRepository/SupabaseRepository.ts';

const selector = `id, customer_id, email, expo_push_token, name, last_name, preferred_name, onboarding_step, dna: dna (
    id,
    data,
    critical_requirements,
    consent_history,
    updated_at
  ), user_features: user_features (
    id,
    trips,
    refinements_per_trip,
    trial_used,
    updated_at
  ), created_at, accepted_tos, accepted_tos_version`;

export class UserRepository extends SupabaseRepository<User> {
  constructor(client: SupabaseClient) {
    super('users', selector, client);
  }
}
